module.exports = __webpack_public_path__ + "img/phones.244cfe4e.png";